import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Button from '../../../components/buttons/Button';
import Icon from '../../../components/icons/Icon';

import { onboardingFinish, onboardingGotoStep } from '../onboardingActions';

import './OnboardingTooltipCloseButton.scss';

const mapDispatchToProps = (dispatch, ownProps) => ({
    onCloseButtonClick: () => {
        if (ownProps.gotoStep) return dispatch(onboardingGotoStep(ownProps.gotoStep));

        dispatch(onboardingFinish());
    },
});

const OnboardingTooltipCloseButton = ({ onCloseButtonClick }) => (
    <Button className="OnboardingTooltipCloseButton" onClickFn={onCloseButtonClick}>
        <Icon name="close-x-small" />
    </Button>
);

OnboardingTooltipCloseButton.propTypes = {
    onCloseButtonClick: PropTypes.func,
    gotoStep: PropTypes.string,
};

export default connect(null, mapDispatchToProps)(OnboardingTooltipCloseButton);
